export class TypesInfo {
    typeId: number;
    type: string;

    constructor(typeId: number, type: string) {
        this.typeId = typeId;
        this.type = type;
    }
}